module.exports = __webpack_public_path__ + "img/news-banner.2c2722ff.png";